import { gql } from '@apollo/client';
import {
  SH_STRUCTURE_BASE_FRAGMENT,
  SH_STRUCTURE_MEDIA_FRAGMENT,
  SH_STRUCTURE_COLLABORATORS_FRAGMENT,
  SH_STRUCTURE_INSTRUCTORS_FRAGMENT,
  SH_FIELD_FRAGMENT,
} from './fragments.js';

export const GET_SH_SETTINGS_VIEW = gql`
  query GetShSettingsView(
    $structureId: ID
    $withFields: Boolean!
    $withStructureInstructors: Boolean = false
    $withStructureCollaborators: Boolean = false
    $withStructureMedia: Boolean = false
  ) {
    shSelectedStructureId @client
    MDB {
      id
      _SH_ {
        id
        structures {
          ...ShStructureBaseFields
          ...ShStructureInstructorsFields @include(if: $withStructureInstructors)
          ...ShStructureCollaboratorsFields @include(if: $withStructureCollaborators)
          ...ShStructureMediaFields @include(if: $withStructureMedia)
        }
        fieldTypes {
          id
          label {
            it
            en
          }
          defaults {
            slotDuration
            maxPlayers
            playersPerTeam
            slotStrategy
          }
        }
        fields: fields(structureId: $structureId) @include(if: $withFields) {
          ...ShFieldFields
        }
      }
    }
  }
  ${SH_STRUCTURE_BASE_FRAGMENT}
  ${SH_STRUCTURE_INSTRUCTORS_FRAGMENT}
  ${SH_STRUCTURE_COLLABORATORS_FRAGMENT}
  ${SH_STRUCTURE_MEDIA_FRAGMENT}
  ${SH_FIELD_FRAGMENT}
`;

export const GET_SH_GOOGLE_PLACES = gql`
  query GetShGooglePlaces($input: String!) {
    _SH_ {
      googlePlacesAutocomplete(input: $input) {
        description
        placeId
        mainText
        secondaryText
      }
    }
  }
`;
